module.exports = {"510402001":"大渡口街道","510402002":"炳草岗街道","510402005":"弄弄坪街道","510402009":"瓜子坪街道","510402010":"东华街道","510402100":"银江镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/510402.json
// module id = 2411
// module chunks = 0